const responsive = "vertical";
const tableBodyHeight = "100vh";

export const mainOptions = {
  selectableRows: "none",
  elevation: 1,
  serverSide: true,
  filter: false,
  print: false,
  filterType: "dropdown",
  download: false,
  viewColumns: false,
  rowsPerPageOptions: [10, 20, 50, 100],
  textLabels: {
    toolbar: {
      search: "جستجو",
      downloadCsv: "دانلود فایل اکسل",
      print: "چاپ",
      viewColumns: "نمایش ستون‌ها",
      filterTable: "فیلتر جدول",
    },
    filter: {
      all: "همه",
      title: "فیلترها",
      reset: "بازنشانی",
    },
    viewColumns: {
      title: "نمایش ستون ها",
      titleAria: "نمایش/عدم نمایش ستون‌های جدول",
    },
    selectedRows: {
      text: "ردیف انتخاب شده",
      delete: "حذف",
      deleteAria: "حذف کردن این ردیف",
    },
    pagination: {
      next: "بعدی",
      previous: "قبلی",
      rowsPerPage: "ردیف در هر صفحه:",
      displayRows: "از",
    },
  },
  search: false,
  responsive,
  // tableBodyHeight
};
